module.exports = __webpack_public_path__ + "img/folder-adset.f79b110b.svg";